import { call, put, delay } from "redux-saga/effects";
import { setCategories, setFeaturedProducts, setSubCategories } from "../actions";
import axios from "axios";
import Cookies from 'js-cookie'

const requestGetCategories = () => {
    return axios.request({
        headers: {
            'Content-Type': 'application/json',
            'Authorization': Cookies.get('token')
        },
        method: 'get',
        url: `${process.env.REACT_APP_SERVER_URL}/v1/products/get-featured-categories`
    })
}


const requestGetSubCategories = (categoryId) => {
    // alert('yes')
    return axios.request({
        headers: {
            'Content-Type': 'application/json',
            'Authorization': Cookies.get('token')
        },
        method: "get",
        url: `${process.env.REACT_APP_SERVER_URL}/v1/products/get-sub-categories?categoryId=${categoryId}`
    })
}

const requestGetFeaturedProducts = (subCategoryId) => {
    return axios.request({
        headers: {
            'Content-Type': 'application/json',
            'Authorization': Cookies.get('token')
        },
        method: "get",
        url: `${process.env.REACT_APP_SERVER_URL}/v1/products/get-featured-products?subCategoryId=${subCategoryId}`
    })
}

export function* handleGetFeaturedProducts(action) {
    const { callback } = action.payload;
    try {
        const categories = yield call(requestGetCategories);
        yield put(setCategories(categories.data));
        for (let i = 0; i < categories.data.length; i++) {
            let subCategories = yield call(requestGetSubCategories, categories.data[i]._id);
            // yield delay(1000);
            yield put(setSubCategories(subCategories.data, i));
            for (let j = 0; j < subCategories.data.length; j++) {
                let featuredProducts = yield call(requestGetFeaturedProducts, subCategories.data[j]._id);
                // yield delay(1000);
                yield put(setFeaturedProducts(featuredProducts.data, i, j));
            }
        }
        callback();
    }
    catch (error) {
        if (callback)
            callback();
        console.log(error)
    }
}

// export function* handleGetSubCategories(action) {
//     try {
//         const { categoryId, categoryIndex } = action.payload;
//         const response = yield call(requestGetSubCategories, categoryId);
//         console.log("Axios response for subCategories: ", response.data);
//         yield put(setSubCategories(response.data, categoryIndex));
//     }
//     catch (error) {
//         console.log(error)
//     }
// }


// export function* handleGetFeaturedProducts(action) {
//     try {
//         const { subCategoryId, categoryIndex, subCategoryIndex } = action.payload;
//         // console.log("SubCategoryId in saga handler: ", subCategoryId);
//         const response = yield call(requestGetFeaturedProducts, subCategoryId);
//         console.log("Axios response for featuredProducts: ", response.data);
//         yield put(setFeaturedProducts(response.data, categoryIndex, subCategoryIndex));
//     }
//     catch (error) {
//         console.log(error)
//     }
// }